// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__k3RTe","containerInner":"Footer_containerInner__3sffQ","links":"Footer_links__222x4"};